

import React, { memo } from 'react';
import _isEmpty from 'lodash.isempty';
import TeamCredits from './TeamCredits';
import '../styles/_payment-options.scss';
import { Text } from '../../../../../../../ui-kit';











function PaymentOptions({
  showCreditInfo,
  orgCreditInfo,
  teamCreditInfo,
  onSelectTeam,
  isSaveDisabled,
  showBufferWarning,
  loading
}) {
  return (
    <>
      {showCreditInfo &&
      <TeamCredits
        teamCreditInfo={teamCreditInfo}
        orgCreditInfo={orgCreditInfo}
        onSelectTeam={onSelectTeam}
        creditType="TEAM"
        isSaveDisabled={isSaveDisabled}
        showBufferWarning={showBufferWarning} />}


      {_isEmpty(teamCreditInfo) && isSaveDisabled && !loading ?

      <Text className="addons-payment__foot-note" danger heading5>
            Please contact your Admin to purchase more Video Credits.
          </Text> :
      null}
      {showBufferWarning ?

      <Text className="addons-payment__foot-note" warning heading5>
            Please note flex credits will be utilised for submitting this project.
          </Text> :
      null}
    </>);

}

export default memo(PaymentOptions);